var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Abonnement bearbeiten",
        size: "lg",
        "ok-text": "Speichern",
        "ok-disabled": _vm.saving,
        "ok-loading": _vm.saving
      },
      on: {
        ok: _vm.save,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _vm.loading
        ? _c("Loading")
        : [
            _c(
              "FormGroup",
              {
                attrs: {
                  label: "Automatische Verlängerung",
                  "label-classes": ["font-weight-bold"]
                }
              },
              [
                _c(
                  "b-form-checkbox",
                  {
                    model: {
                      value: _vm.autoRenew,
                      callback: function($$v) {
                        _vm.autoRenew = $$v
                      },
                      expression: "autoRenew"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\tDas Abonnement soll sich am Ende der Laufzeit automatisch verlängern.\n\t\t\t"
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormGroup",
              {
                staticClass: "mt-4",
                attrs: {
                  label: "Produkt",
                  "label-classes": ["font-weight-bold"]
                }
              },
              [
                _c("div", { staticClass: "mb-1" }, [
                  _vm._v(
                    "Die Änderung des Produkts wird zur nächsten Verlängerung wirksam."
                  )
                ]),
                _vm._v(" "),
                _c("Select", {
                  attrs: {
                    options: _vm.productOptions,
                    "empty-value": null,
                    "empty-value-label": "Keine Produktänderung"
                  },
                  model: {
                    value: _vm.followUpProductId,
                    callback: function($$v) {
                      _vm.followUpProductId = $$v
                    },
                    expression: "followUpProductId"
                  }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }